export default __webpack_public_path__ + "static/media/container_tracking.1b05ae73.svg";